import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, CalendarDays } from "lucide-react";
import { BLOGS } from "@/lib/content";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("nl-NL", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return "";
  }
}

export default function BlogList() {
  const posts = BLOGS;

  return (
    <div data-testid="blog-list-page">
      <section className="bg-[#2C3E50] text-white">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 text-center">
          <span className="inline-block text-xs uppercase tracking-[0.2em] font-medium bg-white/15 px-4 py-1.5 rounded-full mb-5">
            Blog &amp; Tips
          </span>
          <h1 className="font-heading text-4xl md:text-5xl font-black tracking-tighter">
            Slim besparen op tickets
          </h1>
          <p className="mt-4 text-lg text-slate-300 max-w-2xl mx-auto">
            Gidsen, tips en het laatste nieuws over concerten, festivals en vliegtickets.
          </p>
        </div>
      </section>

      <section className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {posts.map((p, i) => (
            <motion.article
              key={p.slug}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
            >
              <Link
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="group block rounded-2xl overflow-hidden bg-white border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] hover:-translate-y-1 transition-all h-full"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={p.image}
                    alt={p.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 text-xs text-slate-400 mb-3">
                    <span className="bg-[#FF6B35]/10 text-[#FF6B35] font-semibold px-2.5 py-1 rounded-full">
                      {p.category}
                    </span>
                    <span className="inline-flex items-center gap-1">
                      <CalendarDays size={13} /> {formatDate(p.published_at)}
                    </span>
                  </div>
                  <h2 className="font-heading text-lg font-bold text-[#2C3E50] leading-snug">{p.title}</h2>
                  <p className="mt-2 text-sm text-slate-600 line-clamp-3">{p.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#FF6B35]">
                    Lees meer <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            </motion.article>
          ))}
        </div>
      </section>
    </div>
  );
}
